import constants from '@/plugins/vue-constants/constants';

const COMMENT = {
  name: 'comment',
  icon: 'mdi-comment-outline',
  iconNegative: 'icon-ayudadigital-comentar-negativo',
  key: 'ticketActions.comment.title',
  // when action should be rendered
  availability: (ticket, user, suscriptor) => {
    const isNotCompleted = !['FIX', 'PL_ENT', 'CL', 'CNCL'].includes((ticket.status || {}).relAttr);
    const userIsTicketCustomer = ticket.customer != null && ticket.customer.id === user.id;
    const userIsTicketRequestedBy = ticket.requestedBy != null && ticket.requestedBy.id === user.id;
    const userIsTicketAssignee = ticket.assignee != null && ticket.assignee.id === user.id;
    const isUserSuscriptor = suscriptor
      .some((subscriber) => subscriber.uuid === user.id) || false;
    return isNotCompleted && (
      userIsTicketCustomer
      || userIsTicketRequestedBy
      || userIsTicketAssignee
      || isUserSuscriptor
    );
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Comment.vue'),
};

const ACCEPT_CLOSING = {
  name: 'acceptClosing',
  icon: 'mdi-check',
  iconNegative: 'icon-ayudadigital-aceptar-negativo',
  key: 'ticketActions.acceptClosing.title',
  availability: (ticket, user, suscriptor) => {
    const isUserSuscriptor = suscriptor
      .some((subscriber) => subscriber.uuid === user.id) || false;
    const isTicketCustomer = (ticket.customer || {}).id === user.id;
    const canCloseTicket = (ticket.status || {}).relAttr === 'FIX';
    const notCitizen = !user.hasIosUser();
    const isNotProblem = ticket.type.relAttr !== 'P';
    return (isTicketCustomer || isUserSuscriptor) && canCloseTicket && notCitizen && isNotProblem;
  },
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/AcceptClosing.vue'),
};

const CLAIM = {
  name: 'claim',
  icon: 'mdi-file-alert-outline',
  iconNegative: 'icon-ayudadigital-reclamar-negativo',
  key: 'ticketActions.claim.title',
  // when action should be rendered
  availability: (ticket, user, suscriptor) => {
    const claimAllowed = ['OP', 'FIX', 'DEL', 'PL_ENT'].includes((ticket.status || {}).relAttr)
      || ((ticket.status || {}).relAttr === 'PEND_APRO' && ticket.customer != null && ticket.customer.id === user.id);
    // const hasNotParent = ticket.parent == null;
    const userIsTicketCustomer = ticket.customer != null && ticket.customer.id === user.id;
    const isUserSuscriptor = suscriptor
      .some((subscriber) => subscriber.uuid === user.id) || false;
    const isNotProblem = ticket.type.relAttr !== 'P';
    const isNotPeticionSeguimientoReclamacion = ticket.category.id !== 402610;
    const notCitizen = !user.hasIosUser();
    return [
      claimAllowed, (userIsTicketCustomer || isUserSuscriptor),
      isNotProblem, isNotPeticionSeguimientoReclamacion, notCitizen,
    ].every((flag) => flag === true);
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Claim.vue'),
};

const CANCEL = {
  name: 'cancel',
  // icon: 'icon-ayudadigital_rechazar',
  icon: 'mdi-cancel',
  iconNegative: 'icon-ayudadigital-cancelar-negativo',
  key: 'ticketActions.cancel.title',
  // when action should be rendered
  availability: (ticket, user, suscriptor) => {
    const allowCancel = ['OP', 'DEL', 'PEND_APRO'].includes((ticket.status || {}).relAttr);
    const userIsTicketCustomer = ticket.customer != null && ticket.customer.id === user.id;
    const isUserSuscriptor = suscriptor
      .some((subscriber) => subscriber.uuid === user.id) || false;
    const isNotProblem = ticket.type.relAttr !== 'P';

    return allowCancel && (userIsTicketCustomer || isUserSuscriptor) && isNotProblem;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Cancel.vue'),
};

const ATTACH = {
  name: 'attach',
  icon: 'mdi-paperclip',
  iconNegative: 'icon-ayudadigital-adjuntar-negativo',
  key: 'ticketActions.attach.title',
  availability: (ticket, user) => {
    const canAttach = (['OP', 'DEL', 'PEND_APRO'].some((status) => (ticket.status || {}).relAttr === status));
    const notCitizen = !user.hasIosUser();
    return canAttach && notCitizen;
  },
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Attach.vue'),
};

const APPROVE = {
  name: 'approve',
  icon: 'mdi-check',
  iconNegative: 'icon-ayudadigital-aceptar-negativo',
  key: 'ticketActions.approve.title',
  // when action should be rendered
  availability: (ticket, user) => {
    const isTicketAssignee = (ticket.assignee || {}).id === user.id;
    const isApprovalWorkFlow = ticket.approbalWorkflowOrder !== -1;
    const canApproveTicket = (ticket.status || {}).relAttr === 'PEND_APRO';
    const notCitizen = !user.hasIosUser();
    const haveApprovalPermissions = user.hasRole('accen_ui_approvals', 'Modify');
    return [
      isTicketAssignee,
      isApprovalWorkFlow,
      canApproveTicket,
      notCitizen,
      haveApprovalPermissions].every((f) => f === true);
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Approve.vue'),
};

const REJECT = {
  name: 'reject',
  icon: 'mdi-close',
  iconNegative: 'icon-ayudadigital-rechazar-negativo',
  key: 'ticketActions.reject.title',
  // when action should be rendered
  availability: (ticket, user) => {
    const canApproveTicket = (ticket.status || {}).relAttr === 'PEND_APRO';
    const isTicketAssignee = (ticket.assignee || {}).id === user.id;
    const haveApprovalPermissions = user.hasRole('accen_ui_approvals', 'Modify');
    const notCitizen = !user.hasIosUser();
    return isTicketAssignee && canApproveTicket && haveApprovalPermissions && notCitizen;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Reject.vue'),
};

const RESOLVE = {
  name: 'resolve',
  icon: 'mdi-progress-check',
  iconNegative: 'icon-ayudadigital-resolver-negativo',
  key: 'ticketActions.resolve.title',
  // when action should be rendered
  availability: (ticket, user) => {
    const isTicketAssignee = (ticket.assignee || {}).id === user.id;
    const isTicketOpened = (ticket.status || {}).relAttr === 'OP';
    const haveCSUPermissions = user.hasRole('accen_ui_csu', 'View') || user.ticGroupMember;
    const notCitizen = !user.hasIosUser();
    return isTicketAssignee && isTicketOpened && haveCSUPermissions && notCitizen;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Resolve.vue'),
};

const ESCALATE = {
  name: 'escalate',
  icon: 'icon-ayudadigital-escalar',
  iconNegative: 'icon-ayudadigital-escalar-negativo',
  key: 'ticketActions.escalate.title',
  // when action should be rendered
  availability: (ticket, user) => {
    const hasNotParent = ticket.parent == null;
    const isTicketAssignee = (ticket.assignee || {}).id === user.id;
    const canApproveTicket = (ticket.status || {}).relAttr === 'PEND_APRO';
    const haveCSUPermissions = user.hasRole('accen_ui_csu', 'View') || user.ticGroupMember;
    const allowEscalate = ['OP', 'DEL'].includes((ticket.status || {}).relAttr);
    const notCitizen = !user.hasIosUser();
    return [
      isTicketAssignee,
      hasNotParent,
      haveCSUPermissions, allowEscalate, notCitizen, canApproveTicket].every((f) => f === true);
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Escalate.vue'),
};

const EXPORT = {
  name: 'export',
  icon: 'icon-ayudadigital-exportar',
  iconNegative: 'icon-ayudadigital-exportar-negativo',
  key: 'ticketActions.export.title',
  // when action should be rendered
  availability: () => true,
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Export.vue'),
};

const CLONE = {
  name: 'clone',
  icon: 'mdi-content-copy',
  key: 'ticketActions.clone.title',
  // when action should be rendered
  availability: () => true,
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Clone.vue'),
};

const TRANSFER = {
  name: 'transfer',
  icon: 'icon-ayudadigital-escalar',
  iconNegative: 'icon-ayudadigital-escalar-negativo',
  key: 'ticketActions.transfer.title',
  // when action should be rendered
  availability: (ticket, user) => {
    const isPendApro = (ticket.status || {}).relAttr === 'PEND_APRO';
    const isTicketAssignee = (ticket.assignee || {}).id === user.id;
    const isTecnical = user.isUserTecnical;
    return [isPendApro, isTicketAssignee, isTecnical].every((f) => f === true);
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import('@/components/ticket-actions/Transfer.vue'),
};

const INTERESADOS = {
  name: 'interesado',
  icon: 'icon-ayudadigital-accion-interesados',
  iconNegative: 'icon-ayudadigital-accion-interesados-negativo',
  key: 'ticketActions.interesado.title',
  // when action should be rendered
  availability: (ticket, user) => {
    const { noActive } = constants.status;
    const isActive = !noActive.includes((ticket.status || {}).relAttr);
    const userIsTicketCustomer = ticket.customer != null && ticket.customer.id === user.id;
    const userIsTicketRequestedBy = ticket.requestedBy != null && ticket.requestedBy.id === user.id;
    const notCitizen = !user.hasIosUser();
    return isActive && (userIsTicketCustomer || userIsTicketRequestedBy) && notCitizen;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import('@/components/ticket-actions/Interesados.vue'),
};

const FOLLOW = {
  name: 'follow',
  icon: 'icon-ayudadigital-ojo',
  iconNegative: 'icon-ayudadigital-ojo',
  key: 'ticketActions.follow.title',
  // when action should be rendered
  availability: (ticket, user, suscriptor, ticketSeguidor) => {
    const {
      isPulso,
      isUserInArray,
      isSuscriptor,
    } = ticketSeguidor;

    if (!isPulso) return false;
    return !isUserInArray && !isSuscriptor;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/Follow.vue'),
};

const FOLLOWNOT = {
  name: 'follownot',
  icon: 'icon-ayudadigital-ojocerrado',
  iconNegative: 'icon-ayudadigital-ojocerrado',
  key: 'ticketActions.follownot.title',
  // when action should be rendered
  availability: (ticket, user, suscriptor, ticketSeguidor) => {
    const {
      isPulso,
      isUserInArray,
      isSeguidor,
      isSuscriptor,
    } = ticketSeguidor;

    if (!isPulso) return false;
    return isUserInArray && !isSuscriptor && isSeguidor;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/FollowNot.vue'),
};

const SHARE = {
  name: 'share',
  icon: 'mdi-share-variant',
  iconNegative: 'mdi-share-variant mdi-share-variantNegative',
  key: 'ticketActions.share.title',
  // when action should be rendered
  availability: (ticket, user, suscriptor, ticketSeguidor) => {
    const {
      isPulso,
    } = ticketSeguidor;

    return isPulso;
  },
  // component rendered on action clicked (lazy component loading)
  component: () => import(/* webpackChunkName: "ticketActions" */ '@/components/ticket-actions/share.vue'),
};

export {
  ACCEPT_CLOSING, APPROVE, ATTACH, CANCEL, CLAIM, CLONE, COMMENT, ESCALATE, EXPORT, FOLLOW,
  FOLLOWNOT, INTERESADOS, REJECT,
  RESOLVE, SHARE, TRANSFER,
};

export default class TicketActionsHandler {
  static ACTIONS = [
    FOLLOW,
    FOLLOWNOT,
    SHARE,
    COMMENT,
    ACCEPT_CLOSING,
    CLAIM,
    CANCEL,
    APPROVE,
    REJECT,
    RESOLVE,
    TRANSFER,
    ESCALATE,
    INTERESADOS,
    ATTACH,
    EXPORT,
    CLONE,
  ];

  static performTicketActions(ticket, user, suscriptor, ticketSeguidor) {
    return TicketActionsHandler.ACTIONS
      .filter((action) => action.availability(ticket, user, suscriptor, ticketSeguidor));
  }
}
